import apiClient from "../../../../../../services/apiClient";

const API_BASE_URL = 'staff-calculation-rules';


export const staffCalculationRulesApi = {
  // Получить все правила с пагинацией и фильтрами
  getAllRules: async (params = {}) => {
    const keys = Object.keys(params).map(k=>`${k}=${params[k]}`);
    const add_q = keys ? ('?' + keys) : '';
    const response = await apiClient.get(API_BASE_URL + add_q);
    return response.data;
  },

  // Получить доступные должности для создания правил
  getAvailablePositions: async () => {
    const response = await apiClient.get(API_BASE_URL + '/positions');
    return response.data;
  },

  // Создать новое правило
  createRule: async (ruleData) => {
    const response = await apiClient.post(API_BASE_URL + '/', ruleData);
    return response.data;
  },

  // Обновить правило
  updateRule: async (id, ruleData) => {
    const response = await apiClient.put(API_BASE_URL + `/${id}`, ruleData);
    return response.data;
  },

  // Удалить правило
  deleteRule: async (id) => {
    const response = await apiClient.delete(API_BASE_URL + `/${id}`);
    return response.data;
  },

  // Активировать/деактивировать правило
  toggleRuleStatus: async (id, isActive) => {
    const response = await apiClient.put(API_BASE_URL + `/${id}/status`, { isActive });
    return response.data;
  },

  // Получить правила для конкретной должности
  getRulesByPosition: async (positionId) => {
    const response = await apiClient.get(API_BASE_URL + `/position/${positionId}`);
    return response.data;
  },

  // Рассчитать штатные единицы
  calculateUnits: async (calculationData) => {
    const response = await apiClient.post(API_BASE_URL + '/calculate', calculationData);
    return response.data;
  },

  // Получить статистику по правилам
  getStatistics: async () => {
    const response = await apiClient.get(API_BASE_URL + '/statistics');
    return response.data;
  },

  // Архивировать правило
  archiveRule: async (id) => {
    return staffCalculationRulesApi.toggleRuleStatus(id, false);
  },

  // Восстановить правило из архива
  restoreRule: async (id) => {
    return staffCalculationRulesApi.toggleRuleStatus(id, true);
  }
};

// Вспомогательные функции для работы с правилами
export const ruleHelpers = {
  // Получить текстовое описание типа правила
  getRuleTypeLabel: (ruleType) => {
    const types = {
      'groups': 'За групами',
      'work_mode': 'За режимом роботи',
      'specialization': 'За спеціалізацією'
    };
    return types[ruleType] || ruleType;
  },

  // Получить описание условий правила
  getConditionDescription: (rule) => {
    switch (rule.ruleType) {
      case 'groups':
        return `Групи: від ${rule.minGroups} до ${rule.maxGroups}`;
      case 'work_mode':
        return `Режим: ${rule.workMode}`;
      case 'specialization':
        return `Спеціалізація: ${rule.specialization}`;
      default:
        return '-';
    }
  },

  // Валидация данных правила
  validateRuleData: (ruleData) => {

    const errors = {};

    if (!ruleData.position) {
      errors.position = 'Посада обов\'язкова';
    }

    if (!ruleData.ruleType) {
      errors.ruleType = 'Тип правила обов\'язковий';
    }

    if (!ruleData.maxUnits || ruleData.maxUnits < 0) {
      errors.maxUnits = 'Максимальна кількість штатних одиниць обов\'язкова та має бути не менше 0';
    }

    if (ruleData.ruleType === 'groups') {
      if (!ruleData.minGroups && ruleData.minGroups !== 0) {
        errors.minGroups = 'Мінімальна кількість груп обов\'язкова';
      }
      if (!ruleData.maxGroups && ruleData.maxGroups !== 0) {
        errors.maxGroups = 'Максимальна кількість груп обов\'язкова';
      }
      if (ruleData.minGroups > ruleData.maxGroups) {
        errors.maxGroups = 'Максимальна кількість груп має бути більшою або рівною мінімальній';
      }
    }

    if (ruleData.ruleType === 'work_mode' && !ruleData.workMode) {
      errors.workMode = 'Режим роботи обов\'язковий';
    }

    if (ruleData.ruleType === 'specialization' && !ruleData.specialization) {
      errors.specialization = 'Спеціалізація обов\'язкова';
    }

    return errors;
  }
};

export default staffCalculationRulesApi;